import React from 'react';
import type { ToastContainerProps } from 'react-toastify';
import Stack from '@mui/material/Stack';
import CloseIcon from '@mui/icons-material/Close';
import Button from '../button';

type ToastActionProps = {
  message: string;
  callback: () => void;
  text: string;
};

const Container = ({ children }: {children: JSX.Element }) => (
  <Stack justifyContent="center">{children}</Stack>
);

export const toastConfig: ToastContainerProps = {
  style: { width: 450, fontSize: '16px' },
  hideProgressBar: true,
  autoClose: 4000,
  position: 'bottom-center',
  theme: 'dark',
  draggable: false,
  closeButton: (<Container><CloseIcon /></Container>),
};

export default function ToastAction({ message, callback, text }: ToastActionProps) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      {message}
      <Button variant="text" color="secondary" onClick={callback}>
        {text}
      </Button>
    </Stack>
  );
}
